import { Gesture, gestureLayers } from "./BaseGesture"

class CollectionViewFileClickToSelectOrOpen extends Gesture {
  override layer = gestureLayers.mainView

  #didSelect = false
  #didClick = false

  override reset() {
    this.#didSelect = false
    this.#didClick = false
  }

  override async onMouseDown(
    mouse: MouseEvent,
  ) {
    const { getCollectionViewFileFromEvent, isPrimaryClick, isOverCollectionView, isCommandKeyChord, isShiftKeyChord } = useGestures()
    const { addFileToSelection, isSelectedIn, deselectFile, isSelectionEmpty } = useSelection()
    const { emitInterfaceEvent } = useEvents()
    if (!isPrimaryClick(mouse) || !isOverCollectionView(mouse))
      return

    const file = getCollectionViewFileFromEvent(mouse)
    if (!file)
      return

    // don't capture as we might not be the last gesture
    this.#didClick = true

    // If shift is pressed, do a multi-select
    if (isCommandKeyChord() || isShiftKeyChord()) {
      // If we are starting a selection, deselect stuff elsewhere in
      // the UI.
      if (isSelectionEmpty())
        emitInterfaceEvent("afterHardBlur", {})

      this.capture()
      this.#didSelect = true
      this.debug(`Multi-select toggling file`, file)
      if (isSelectedIn(file.id, "collection-view"))
        deselectFile(file.id)
      else
        addFileToSelection(file, "collection-view")
      return
    }

    // If we don't have shift pressed, select or open
    if (!isSelectedIn(file.id, "collection-view")) {
      this.debug(`Selecting file`, file)
      this.capture()
      // do a hard blur here to deselect stuff elsewhere in the UI
      emitInterfaceEvent("afterHardBlur", {})
      addFileToSelection(file, "collection-view")
      this.#didSelect = true
    }
  }

  override async onMouseUp(
    mouse: MouseEvent,
  ) {
    const { getCollectionViewFileFromEvent, isPrimaryClick, state: gestureState, isOverCollectionView, clickedCloseEnough } = useGestures()
    const { navigateToFile } = useNavigation()
    const { emitInterfaceEvent } = useEvents()
    if (!isPrimaryClick(mouse) || !isOverCollectionView(mouse))
      return this.reset()

    // Don't navigate on the same click as select
    if (this.#didSelect || !this.#didClick)
      return this.reset()

    // this.debug('not on selection click')

    // if the position of the mouse is where it was on mouse down, then we're a click
    if (!gestureState.value.mouseDown || !clickedCloseEnough(gestureState.value.mouseDown, mouse))
      return this.reset()

    // this.debug('location match')

    const file = getCollectionViewFileFromEvent(mouse)
    if (!file)
      return this.reset()

    // this.debug('file match')

    this.capture()
    emitInterfaceEvent("afterHardBlur", {})
    navigateToFile(file)

    return this.reset()
  }
}

const mainOrWaterfallViewFileClickToSelectOrOpen = new CollectionViewFileClickToSelectOrOpen()
export default function () {
  return mainOrWaterfallViewFileClickToSelectOrOpen
}
